/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GenerateEmailRequest,
  GenerateEmailResponse,
  MemberCodeOutput,
} from '../models/index';
import {
    GenerateEmailRequestFromJSON,
    GenerateEmailRequestToJSON,
    GenerateEmailResponseFromJSON,
    GenerateEmailResponseToJSON,
    MemberCodeOutputFromJSON,
    MemberCodeOutputToJSON,
} from '../models/index';

export interface GenerateEmailOperationRequest {
    partnerUid: string;
    generateEmailRequest: GenerateEmailRequest;
}

export interface GenerateMemberCodeRequest {
    partnerUid: string;
}

export interface GetMemberCodeRequest {
    partnerUid: string;
}

export interface RevokeMemberCodeRequest {
    partnerUid: string;
}

/**
 * 
 */
export class MemberZoneApi extends runtime.BaseAPI {

    /**
     * Creates request options for generateEmail without sending the request
     */
    async generateEmailRequestOpts(requestParameters: GenerateEmailOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling generateEmail().'
            );
        }

        if (requestParameters['generateEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'generateEmailRequest',
                'Required parameter "generateEmailRequest" was null or undefined when calling generateEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/memberzone/partners/{partnerUid}/generateEmail`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateEmailRequestToJSON(requestParameters['generateEmailRequest']),
        };
    }

    /**
     * Generate a prospect email that contains the member code (if no member code is available, a new one is created) - the member code later is used to login customer mobile applications
     * Generate the customer email with getting the member code
     */
    async generateEmailRaw(requestParameters: GenerateEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateEmailResponse>> {
        const requestOptions = await this.generateEmailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateEmailResponseFromJSON(jsonValue));
    }

    /**
     * Generate a prospect email that contains the member code (if no member code is available, a new one is created) - the member code later is used to login customer mobile applications
     * Generate the customer email with getting the member code
     */
    async generateEmail(requestParameters: GenerateEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateEmailResponse> {
        const response = await this.generateEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for generateMemberCode without sending the request
     */
    async generateMemberCodeRequestOpts(requestParameters: GenerateMemberCodeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling generateMemberCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/memberzone/partners/{partnerUid}/code/generate`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generates a new member code and returns back the generated code
     * Generate a new code for a given partner
     */
    async generateMemberCodeRaw(requestParameters: GenerateMemberCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MemberCodeOutput>> {
        const requestOptions = await this.generateMemberCodeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemberCodeOutputFromJSON(jsonValue));
    }

    /**
     * Generates a new member code and returns back the generated code
     * Generate a new code for a given partner
     */
    async generateMemberCode(requestParameters: GenerateMemberCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MemberCodeOutput> {
        const response = await this.generateMemberCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMemberCode without sending the request
     */
    async getMemberCodeRequestOpts(requestParameters: GetMemberCodeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling getMemberCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/memberzone/partners/{partnerUid}/code`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the existing memeber code information for an given eligible partner
     * Gets the existing memeber code information for an given eligible partner
     */
    async getMemberCodeRaw(requestParameters: GetMemberCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MemberCodeOutput>> {
        const requestOptions = await this.getMemberCodeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemberCodeOutputFromJSON(jsonValue));
    }

    /**
     * Gets the existing memeber code information for an given eligible partner
     * Gets the existing memeber code information for an given eligible partner
     */
    async getMemberCode(requestParameters: GetMemberCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MemberCodeOutput> {
        const response = await this.getMemberCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for revokeMemberCode without sending the request
     */
    async revokeMemberCodeRequestOpts(requestParameters: RevokeMemberCodeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling revokeMemberCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/memberzone/partners/{partnerUid}/code/revoke`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Revokes a existing code for a given partner
     * Revokes a existing code for a given partner
     */
    async revokeMemberCodeRaw(requestParameters: RevokeMemberCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MemberCodeOutput>> {
        const requestOptions = await this.revokeMemberCodeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MemberCodeOutputFromJSON(jsonValue));
    }

    /**
     * Revokes a existing code for a given partner
     * Revokes a existing code for a given partner
     */
    async revokeMemberCode(requestParameters: RevokeMemberCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MemberCodeOutput> {
        const response = await this.revokeMemberCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
